import { AuditCard } from "@/pages/a7/Audit/AuditCard";
import i18n from "@/i18n";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button, Link } from "@heroui/react";
import { useParams } from "react-router-dom";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

import { A7OPCVMUnderlyingsEditCard } from "./edit_card";

import { getUnderlyingAuditColumns } from "./columns";

const table_name = "a7_opcvm_underlyings";

export const A7OPCVMUnderlyingsEdit = () => {
  const { id } = useParams<{ id: string }>();
  const { t, i18n: i18nClient } = useTranslation(["tables", "common"]);
  const auditColumns = useMemo(
    () => getUnderlyingAuditColumns(t),
    [t, i18nClient.language],
  );

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full bg-gray-50">
      <div className="flex flex-col gap-10 p-10">
        <div className="flex">
          <div className="flex-grow flex justify-center">
            <A7OPCVMUnderlyingsEditCard id={Number(id)} />
          </div>
          <div>
            <Button
              href={toWorkspacePath(
                `/admin/a7-opcvm/a7_opcvm_underlying_ts?underlying_id_equals=${id}`,
              )}
              variant="bordered"
              color="primary"
              showAnchorIcon
              as={Link}
              radius="full"
              className="bg-white border-1 border-neutral-300 shadow-xl"
            >
              {t("a7_opcvm_underlying_ts.title", {
                ns: "tables",
                defaultValue: "Underlying time series",
              })}
            </Button>
          </div>
        </div>
        <AuditCard
          id={Number(id)}
          name={table_name}
          audit_columns={auditColumns}
          client="a7"
        />
      </div>
    </div>
  );
};
